import { createDraftSafeSelector } from '@reduxjs/toolkit';
import type { RootState } from '../../App/Store';

export const getState = (state: RootState) => state.elapsedTime;

export const getTotalElapsedTime = createDraftSafeSelector(
  getState,
  ({ timeByStep }) => Object.values(timeByStep).reduce((acc: number, time) => acc + time, 0),
);
